module.exports = __webpack_public_path__ + "static/img/title_img2.8176bc0.svg";


//////////////////
// WEBPACK FOOTER
// ./static/imgs/VXImage/title_img2.svg
// module id = CyIp
// module chunks = 0